import React from 'react';

export const adornmentStyle: React.CSSProperties = {
	padding: 0,
	margin: 0,
	paddingRight: 0,
	width: 48,
	minHeight: 48,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: 'var(--surface-secondary, #FAFBFC)',
};
